// extracted by mini-css-extract-plugin
export default {"ipt":"index_ipt_keOiJ","bar":"index_bar_Y6e9E"};